module.exports = __webpack_public_path__ + "img/MapPicsAcropolis.153caed4.webp";